import type { ReactNode } from "react";
import { Icon, type IconComponent } from "./icons";

export interface EmptyStateProps {
  icon?: IconComponent;
  title: ReactNode;
  description?: ReactNode;
  action?: ReactNode;
}

export function EmptyState({
  icon: I = Icon.FileText,
  title,
  description,
  action,
}: EmptyStateProps) {
  return (
    <div className="text-center py-20 px-6">
      <div className="inline-flex items-center justify-center mb-6 text-[var(--ink-4)]">
        <I size={32} strokeWidth={1.5} />
      </div>
      <div className="display-5 mb-2">{title}</div>
      {description && <div className="body max-w-md mx-auto mb-6">{description}</div>}
      {action}
    </div>
  );
}
